import axiosInstance from "services/common/axiosInstance";

const handleRequest = async (promise: Promise<any>) => {
  try {
    const response = await promise;
    return response.data;
  } catch (error: any) {
    throw error?.response?.data || error.message;
  }
};

const BASE_URL = "/tips";

export const addTipApi = (data: any) =>
  handleRequest(axiosInstance.post(`${BASE_URL}/addnewtips`, data));

export const updateTipApi = (tip_id: number, data: any) =>
  handleRequest(
    axiosInstance.put(`${BASE_URL}/updatetips`, data, { params: { tip_id } })
  );

export const deleteTipApi = (tip_id: number) =>
  handleRequest(
    axiosInstance.delete(`${BASE_URL}/deletetips`, { params: { tip_id } })
  );

export const fetchTipsListApi = (data: any) =>
  handleRequest(axiosInstance.post(`${BASE_URL}/getalltipsforadmin`, data));

export const fetchTipsCategoryApi = () =>
  handleRequest(axiosInstance.get(`${BASE_URL}/gettipscategoryadmin`));

export const fetchTipsCriteriaApi = () =>
  handleRequest(axiosInstance.get(`${BASE_URL}/gettipscriteriaadmin`));

export const fetchDeliveryMethodApi = () =>
  handleRequest(axiosInstance.get(`${BASE_URL}/gettipsdeliverymethodadmin`));
